export default __webpack_public_path__ + "static/char-s-45-en-5310badd6cbe835962babe76b70913e3.webp";